import { render, staticRenderFns } from "./BrandTutorialVideos.vue?vue&type=template&id=a2c546b8&scoped=true&"
import script from "./BrandTutorialVideos.vue?vue&type=script&lang=ts&"
export * from "./BrandTutorialVideos.vue?vue&type=script&lang=ts&"
import style0 from "./BrandTutorialVideos.vue?vue&type=style&index=0&id=a2c546b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c546b8",
  null
  
)

export default component.exports